import request from "@/utils/request";

export function getSiteSections(params) {
  return request({
    url: "/api/admin/site_section/",
    method: "get",
    params,
  });
}

export function postSiteSection(data) {
  return request({
    url: "/api/admin/site_section/",
    method: "post",
    data,
  });
}

export function getSiteSectionID(id) {
  return request({
    url: `/api/admin/site_section/${id}/`,
    method: "get",
  });
}

export function patchSiteSection(id, data) {
  return request({
    url: `/api/admin/site_section/${id}/`,
    method: "patch",
    data,
  });
}
